(function () {
          var el = document.getElementById('menahub-fulfilment-card');
          if (!el) return;
          var pid = parseInt(el.getAttribute('data-product-id'), 10);
          if (!pid) return;

          // If staff flagged the product out of stock (price 0 or an
          // unavailable variant), never show the delivery card — the red
          // "Out of Stock" label is the only fulfilment signal, matching the
          // product-card behaviour. This wins even if the backend's stock
          // data still says in-stock.
          if (window.menahubPdpOos === true) { el.remove(); return; }

          fetch('https://admin.menahub.com/api/fulfilment_resolve.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(Object.assign({ product_ids: [pid] }, (function(){ var sa = /(?:^|; )mh_market=sa(?:;|$)/.test(document.cookie); var ar = (document.documentElement.lang || '').indexOf('ar') === 0 || /^\/ar(\/|$)/.test(location.pathname); return sa ? { market: 'sa', lang: ar ? 'ar' : 'en' } : {}; })()))
          })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (json) {
              if (!json || !json.fulfilment) return;
              var f = json.fulfilment[String(pid)];
              if (!f || !f.show_badge) return;
              paint(el, f);
            })
            .catch(function () {});

          function paint(host, f) {
            var style = f.pill_style || (f.source === 'default' ? 'standard' : 'express_yellow');
            host.className = 'mh-fc mh-fc--' + style;

            // Hover note explaining the after-cutoff delivery policy. Shows as a
            // native tooltip on the whole delivery card.
            host.title = 'Next Day Delivery: Orders placed after 5 PM will be delivered the next day.';

            // Tag <body> when this product has a real express promise (yellow
            // Noon pill or blue GET-IN pill). CSS uses that flag to hide the
            // right-column "DELIVERY INFORMATION" widget, which is rendered
            // from legacy metafields and doesn't know about the dynamic
            // collection_override / product_override cascade — so without
            // this flag the right column says "Free Delivery Standard" while
            // the centre says "Tomorrow", contradicting itself.
            if (style === 'express_yellow' || style === 'get_in_blue' || style === 'get_delivery_purple') {
              document.body.classList.add('mh-pdp-has-express');
            }

            // Icon — truck for standard, lightning for express/get-in
            var icon = document.createElement('div');
            icon.className = 'mh-fc__icon';
            icon.appendChild(makeIcon(style));

            var body = document.createElement('div');
            body.className = 'mh-fc__body';

            var title = document.createElement('div');
            title.className = 'mh-fc__title';
            title.textContent = friendlyTitle(f);

            var sub = document.createElement('div');
            sub.className = 'mh-fc__sub';
            sub.textContent = friendlySub(f);

            body.appendChild(title);
            body.appendChild(sub);

            // Optional countdown banner (deal pages with timers)
            if (f.timer && f.timer.expires_at) {
              var cd = buildCountdown(f.timer);
              if (cd) body.appendChild(cd);
            }

            host.appendChild(icon);
            host.appendChild(body);

            // Right-aligned highlight chip for promoted styles
            if (style !== 'standard' && f.label) {
              var chip = document.createElement('span');
              chip.className = 'mh-fc__chip';
              chip.textContent = f.label;
              host.appendChild(chip);
            }

            // Same-day only: show a visible, clickable support/assistance number
            // beneath the delivery card. Keyed on the "Same Day" label so it
            // disappears automatically once the cutoff flips it to "Next Day".
            if ((f.label || '').toLowerCase().trim() === 'same day') {
              var support = buildSameDaySupport();
              if (host.parentNode && !document.getElementById('mh-sameday-support')) {
                host.parentNode.insertBefore(support, host.nextSibling);
              }
            }
          }

          // Visible + clickable same-day support: tap to call (tel:) or WhatsApp.
          function buildSameDaySupport() {
            var PHONE_DISPLAY = '+974 3111 4248';
            var TEL = 'tel:+97431114248';
            var WA  = 'https://wa.me/97431114248?text=' +
                      encodeURIComponent('Hi, I need help with my same-day delivery order.');
            var svgNS = 'http://www.w3.org/2000/svg';

            var box = document.createElement('div');
            box.id = 'mh-sameday-support';
            box.className = 'mh-sds';

            var ico = document.createElement('span');
            ico.className = 'mh-sds__ico';
            var phoneSvg = document.createElementNS(svgNS, 'svg');
            phoneSvg.setAttribute('viewBox', '0 0 24 24');
            phoneSvg.setAttribute('fill', 'none');
            phoneSvg.setAttribute('stroke', 'currentColor');
            phoneSvg.setAttribute('stroke-width', '2');
            phoneSvg.setAttribute('stroke-linecap', 'round');
            phoneSvg.setAttribute('stroke-linejoin', 'round');
            var phonePath = document.createElementNS(svgNS, 'path');
            phonePath.setAttribute('d', 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z');
            phoneSvg.appendChild(phonePath);
            ico.appendChild(phoneSvg);

            var bodyEl = document.createElement('div');
            bodyEl.className = 'mh-sds__body';
            var lead = document.createElement('div');
            lead.className = 'mh-sds__lead';
            lead.textContent = 'Need help with your same-day delivery? Call or WhatsApp us:';
            var row = document.createElement('div');
            row.className = 'mh-sds__row';

            var call = document.createElement('a');
            call.className = 'mh-sds__call';
            call.href = TEL;
            call.textContent = PHONE_DISPLAY;

            var wa = document.createElement('a');
            wa.className = 'mh-sds__wa';
            wa.href = WA;
            wa.target = '_blank';
            wa.rel = 'noopener';
            var waIco = document.createElementNS(svgNS, 'svg');
            waIco.setAttribute('viewBox', '0 0 24 24');
            waIco.setAttribute('fill', '#fff');
            var waPath = document.createElementNS(svgNS, 'path');
            waPath.setAttribute('d', 'M12 2a10 10 0 0 0-8.6 15L2 22l5.1-1.3A10 10 0 1 0 12 2zm5.3 14.2c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .1-1.7-.1-.4-.1-1-.3-1.6-.6-2.9-1.2-4.7-4.1-4.9-4.3-.1-.2-1.1-1.5-1.1-2.8 0-1.3.7-2 .9-2.2.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2.1.4 0 .5l-.4.6c-.2.2-.3.4-.1.7.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.4 2.4 1.5.2.1.4.1.6-.1l.7-.9c.2-.2.4-.2.6-.1l1.8.9c.3.1.4.2.5.3.1.2.1.7-.1 1.3z');
            waIco.appendChild(waPath);
            wa.appendChild(waIco);
            wa.appendChild(document.createTextNode('WhatsApp'));

            row.appendChild(call);
            row.appendChild(wa);
            bodyEl.appendChild(lead);
            bodyEl.appendChild(row);
            box.appendChild(ico);
            box.appendChild(bodyEl);
            return box;
          }

          function makeIcon(style) {
            var svgNS = 'http://www.w3.org/2000/svg';
            var svg = document.createElementNS(svgNS, 'svg');
            svg.setAttribute('viewBox', '0 0 24 24');
            svg.setAttribute('fill', 'none');
            svg.setAttribute('stroke', 'currentColor');
            svg.setAttribute('stroke-width', '2');
            svg.setAttribute('stroke-linecap', 'round');
            svg.setAttribute('stroke-linejoin', 'round');
            if (style === 'get_in_blue' || style === 'express_yellow' || style === 'get_delivery_purple') {
              // Lightning bolt
              var bolt = document.createElementNS(svgNS, 'polygon');
              bolt.setAttribute('points', '13 2 3 14 12 14 11 22 21 10 12 10 13 2');
              svg.appendChild(bolt);
            } else {
              // Truck
              var r = document.createElementNS(svgNS, 'rect');
              r.setAttribute('x', '1'); r.setAttribute('y', '3');
              r.setAttribute('width', '15'); r.setAttribute('height', '13');
              var p = document.createElementNS(svgNS, 'polygon');
              p.setAttribute('points', '16 8 20 8 23 11 23 16 16 16 16 8');
              var c1 = document.createElementNS(svgNS, 'circle');
              c1.setAttribute('cx', '5.5'); c1.setAttribute('cy', '18.5'); c1.setAttribute('r', '2.5');
              var c2 = document.createElementNS(svgNS, 'circle');
              c2.setAttribute('cx', '18.5'); c2.setAttribute('cy', '18.5'); c2.setAttribute('r', '2.5');
              svg.appendChild(r); svg.appendChild(p); svg.appendChild(c1); svg.appendChild(c2);
            }
            return svg;
          }

          function friendlyTitle(f) {
            if (f.source === 'delivery_paused')     return f.label || 'Delivery paused';
            // Standard delivery: show the label as-is ("Standard delivery"), not
            // "Get it by ..." — this is a delivery TERM, not an ETA date.
            if (f.type === 'standard')              return f.label || 'Standard delivery';
            if (f.pill_style === 'get_delivery_purple') return 'Get Online delivery ' + (f.label || '');
            if (f.pill_style === 'get_in_blue')     return 'Get it in ' + (f.label || '');
            // express_yellow default + same-day/override labels
            return 'Get it by ' + (f.label || 'Tomorrow');
          }

          function friendlySub(f) {
            if (f.source === 'delivery_paused') return 'Deliveries resume soon.';
            // Standard delivery gets the 2-3 day promise as its description.
            if (f.type === 'standard')          return 'Delivery in 2-3 days.';
            if (f.before_cutoff === true)  return 'Order in the next few hours to qualify.';
            if (f.before_cutoff === false) return 'Order today for delivery after the cut-off.';
            if (f.source === 'product_override' || f.source === 'collection_override') return 'Promoted delivery for this product.';
            return 'Delivery as soon as we can dispatch.';
          }

          function buildCountdown(timer) {
            var expiresAt = Date.parse(String(timer.expires_at).replace(' ', 'T'));
            if (isNaN(expiresAt) || expiresAt <= Date.now()) return null;
            var wrap = document.createElement('div');
            wrap.className = 'mh-fc__countdown';
            var svgNS = 'http://www.w3.org/2000/svg';
            var icon = document.createElementNS(svgNS, 'svg');
            icon.setAttribute('viewBox', '0 0 24 24');
            icon.setAttribute('fill', '#fff');
            var p = document.createElementNS(svgNS, 'path');
            p.setAttribute('d', 'M6 2h12v2l-4 6 4 6v2H6v-2l4-6-4-6V2z');
            icon.appendChild(p);
            var timerEl = document.createElement('span');
            timerEl.textContent = '--:--';
            wrap.appendChild(icon);
            wrap.appendChild(timerEl);

            // Optional stock-percent text
            if (typeof timer.stock_percent_left === 'number') {
              var pct = document.createElement('span');
              pct.textContent = '· ' + timer.stock_percent_left + '% Left';
              wrap.appendChild(pct);
            }

            function tick() {
              var ms = expiresAt - Date.now();
              if (ms <= 0) { wrap.remove(); return false; }
              var totalMin = Math.floor(ms / 60000);
              var h = Math.floor(totalMin / 60);
              var m = totalMin % 60;
              var s = Math.floor((ms % 60000) / 1000);
              timerEl.textContent = (h > 0)
                ? (String(h).padStart(2, '0') + 'h:' + String(m).padStart(2, '0') + 'm')
                : (String(m).padStart(2, '0') + 'm:' + String(s).padStart(2, '0') + 's');
              return true;
            }
            tick();
            var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
            return wrap;
          }
        })();
